module.exports = __webpack_public_path__ + "1339b0937dfbc39a4b8ef1ad4dbc333d.svg";